import { PencilSimple } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import {
  useSubmitUserInput,
  useCompareModeSubmit,
  useComparingConversationsParams,
  useChatHistory,
} from 'src/hooks';
import { Button } from 'src/v2/commonComponents/Button';

const SUBMIT_INPUT = 'Continue';

interface ContinueAnsweringButtonProps {
  disabled: boolean;
}

export const ContinueAnsweringButton = ({
  disabled,
}: ContinueAnsweringButtonProps) => {
  const { isNinjaRetired } = useChatHistory();
  const { isCompareMode } = useComparingConversationsParams();
  const { onSubmitUserInput } = useSubmitUserInput();
  const { onCompareModeSubmit } = useCompareModeSubmit();

  const handleClick = () => {
    if (isCompareMode) {
      onCompareModeSubmit(SUBMIT_INPUT);
    } else {
      onSubmitUserInput({ userInput: SUBMIT_INPUT });
    }
  };

  if (isNinjaRetired) {
    return null;
  }

  return (
    <Button
      tooltipContent="Have Ninja to refine or continue the previous answer"
      color="secondary-outline"
      onClick={handleClick}
      disabled={disabled}
    >
      <PencilSimple size={SVG_SIZE_M} />
      Continue answering
    </Button>
  );
};
